module.exports = __webpack_public_path__ + "static/manic-owl-white-b2fb3a7839be9f3339d9a3f3a634b514.svg";